import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QualityAssuranceState } from '@app/quality-assurance/state/quality-assurance.state';
import { ReviewTypeTile } from '@app/quality-assurance/models/responses/review-type.tile';

export const getQualityAssuranceFeatureState =
  createFeatureSelector<QualityAssuranceState>('qualityAssurance');

const getReviewState = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.review,
);

export const getReview = createSelector(getReviewState, (state) => state.data);

export const getReviewIsLoading = createSelector(
  getReviewState,
  (state) => state.isLoading,
);

export const getReviewError = createSelector(
  getReviewState,
  (state) => state.error,
);

const getFindingsState = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.findings,
);

export const getFindings = createSelector(
  getFindingsState,
  (state) => state.data,
);

const getFindingState = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.finding,
);

export const getFinding = createSelector(
  getFindingState,
  (state) => state.data,
);

export const getFindingIsLoading = createSelector(
  getFindingState,
  (state) => state.isLoading,
);

export const getFindingError = createSelector(
  getFindingState,
  (state) => state.error,
);

export const getIsCreatingClaimReview = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isCreatingClaimReview,
);

const getReviewFindingsState = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.reviewFindings,
);

export const getReviewFinding = (findingId: number) =>
  createSelector(
    getReviewFindingsState,
    (state) => state[findingId]?.data ?? null,
  );

export const getReviewFindingIsLoading = (findingId: number) =>
  createSelector(
    getReviewFindingsState,
    (state) => state[findingId]?.isLoading ?? false,
  );

export const getReviewFindingError = (findingId: number) =>
  createSelector(
    getReviewFindingsState,
    (state) => state[findingId]?.error ?? null,
  );
const getClaimReviewsState = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.claimReviews,
);

export const getClaimReviews = createSelector(
  getClaimReviewsState,
  (state) => state.data,
);

export const getClaimReviewsIsLoading = createSelector(
  getClaimReviewsState,
  (state) => state.isLoading,
);

export const getClaimReviewsError = createSelector(
  getClaimReviewsState,
  (state) => state.error,
);
const getFindingMetadataState = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.findingMetadata,
);

export const getFindingMetadata = createSelector(
  getFindingMetadataState,
  (state) => state.data,
);

export const getFindingMetadataIsLoading = createSelector(
  getFindingMetadataState,
  (state) => state.isLoading,
);

export const getFindingMetadataError = createSelector(
  getFindingMetadataState,
  (state) => state.error,
);
export const getIsReviewingFinding = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isReviewingFinding,
);
export const getIsCreatingComment = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isCreatingComment,
);

const getCommentsState = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.comments,
);

export const getComments = createSelector(
  getCommentsState,
  (state) => state.data,
);

export const getCommentsIsLoading = createSelector(
  getCommentsState,
  (state) => state.isLoading,
);

export const getCommentsError = createSelector(
  getCommentsState,
  (state) => state.error,
);

export const selectSelectedReviewType = createSelector(
  getQualityAssuranceFeatureState,
  (s) => s.selectedReviewType,
);
const selectReviewTypeTilesState = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.reviewTypeTiles,
);

export const selectReviewTypeTiles = createSelector(
  selectReviewTypeTilesState,
  (tiles: ReviewTypeTile[]) => tiles,
);
const getProjectState = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.project,
);
export const getProject = createSelector(
  getProjectState,
  (state) => state.data,
);

export const getProjectIsLoading = createSelector(
  getProjectState,
  (state) => state.isLoading,
);

export const getProjectError = createSelector(
  getProjectState,
  (state) => state.error,
);
export const getIsMarkingInclusion = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isMarkingInclusion,
);
export const getIsRoundTableReviewing = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isRoundTableReviewing,
);
export const getIsReviewingEscalation = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isReviewingEscalation,
);
export const getIsClosingReview = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isClosingReview,
);
const getReviewSummaryState = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.reviewSummary,
);
export const getReviewSummary = createSelector(
  getReviewSummaryState,
  (state) => state.data,
);

export const getReviewSummaryIsLoading = createSelector(
  getReviewSummaryState,
  (state) => state.isLoading,
);

export const getReviewSummaryError = createSelector(
  getReviewSummaryState,
  (state) => state.error,
);
export const getIsEditingRoundTableDate = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isEditingRoundTableDate,
);
export const getIsCreatingRoundTableDate = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isCreatingRoundTableDate,
);
export const getIsCreatingProject = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isCreatingProject,
);

export const getIsClosingProject = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isClosingProject,
);
export const getIsGeneratingWorkList = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isGeneratingWorkList,
);
export const getIsActioningWorkList = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isActioningWorkList,
);
export const getIsAssigningReview = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isAssigningReview,
);
const getClaimReviewersState = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.claimReviewers,
);

export const getClaimReviewers = createSelector(
  getClaimReviewersState,
  (state) => state.data,
);

export const getClaimReviewersIsLoading = createSelector(
  getClaimReviewersState,
  (state) => state.isLoading,
);

export const getIsAwardingKudos = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isAwardingKudos,
);

export const getIsActioningRemedialAction = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isActioningRemedialAction,
);

const selectFindingTypeTilesState = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.findingsTypeTiles,
);

export const selectFindingTypeTiles = createSelector(
  selectFindingTypeTilesState,
  (tiles: ReviewTypeTile[]) => tiles,
);

export const getUnActionedQaFindings = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.unActionedQaFindings,
);
export const getProjectsWithApproachingLockdown = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.projectsWithApproachingLockdown,
);
export const getIsUpdatingReviewNote = createSelector(
  getQualityAssuranceFeatureState,
  (state) => state.isUpdatingReviewNote,
);
